import React, { FC, useState } from "react";
import { Alert, AlertTitle, Button, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ConcreteLoginStrategy } from "./LoginStrategy";
import { useIdentityDao } from "../dao/useIdentityDao";

export interface LoginFooterProps {
  username: string;
  loginStrategy: ConcreteLoginStrategy;
  disableForgotPassword?: boolean;
  onNewUser: () => void;
}

export const LoginFooter: FC<LoginFooterProps> = (props) => {
  const { username, onNewUser } = props;
  const disableForgotPassword =
    (props.disableForgotPassword ?? false) || username.isBlank();
  const { t } = useTranslation("shared-ts-ui-identity");
  const [sendResetPasswordStatus, setSendResetPasswordStatus] = useState<
    "none" | "sending" | "sent"
  >("none");
  const identityDao = useIdentityDao();

  const handleForgotPassword = async () => {
    setSendResetPasswordStatus("sending");
    await identityDao.sendChangePasswordEmail({ email: username });
    setSendResetPasswordStatus("sent");
  };
  return (
    <>
      <Stack
        direction={"row"}
        sx={{ width: "100%", justifyContent: "space-evenly" }}
      >
        <Button color={"secondary"} onClick={onNewUser}>
          {t("New User")}
        </Button>
        <Button
          color={"secondary"}
          variant={"text"}
          disabled={disableForgotPassword}
          loading={sendResetPasswordStatus === "sending"}
          onClick={handleForgotPassword}
        >
          {t("Forgot Password")}
        </Button>
      </Stack>
      {sendResetPasswordStatus === "sent" && (
        <Alert severity={"info"}>
          <AlertTitle>
            {t("An e-mail for resetting password will be sent to")}
            {": " + username}
          </AlertTitle>
          {t("if this e-mail matched an existing user")}
        </Alert>
      )}
    </>
  );
};
